import React from "react";

import { Typography } from "@mui/material";

interface SectionHeaderProps {
  title: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ title }) => {
  return (
    <Typography
      sx={{
        fontSize: "12px",
        fontFamily: "Roboto",
        fontWeight: 400,
        color: "#496682",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        padding: "0 15px"
      }}
    >
      {title}
    </Typography>
  );
};
